import { createContext, type PropsWithChildren, useContext, useSyncExternalStore } from "react";
import { getAuthGeneration, subscribeAuthGeneration } from "./client";

const ScopeAuthGenerationContext = createContext<number | undefined>(undefined);

/**
 * 애플리케이션 수준 subscription 하나가 Scope 자격 전환을 담당합니다.
 * 모든 useScope 소비자가 같은 generation을 받아 각자 인증 event listener를 설치하지
 * 않고 React Query 요청 하나를 공유합니다.
 */
export function ScopeAuthLifecycle({ children }: PropsWithChildren) {
  const generation = useSyncExternalStore(
    subscribeAuthGeneration,
    getAuthGeneration,
    getAuthGeneration,
  );
  return (
    <ScopeAuthGenerationContext.Provider value={generation}>
      {children}
    </ScopeAuthGenerationContext.Provider>
  );
}

export function useScopeAuthGeneration() {
  return useContext(ScopeAuthGenerationContext) ?? getAuthGeneration();
}
